import { inject, provideAppInitializer } from "@angular/core";

import { TokenService } from "../../services/tokenservice";

export const AppInitializerTokenProvider = provideAppInitializer(() => {
  const token = inject(TokenService);
  return token.setHttpToken();
});
